import React from "react";

import { LayoutFooter } from "@components-shared/desktop/layout/components/LayoutFooter";
import { DesktopLayoutProps } from "@data-types/layout/DesktopLayoutTypes";

import DesktopHeaderLayout from "./components/DesktopHeaderLayout";

export default function DesktopLayout({
	headerType,
	mainClassName = "l--main l--main--full",
	footerClassName = "l--footer",
	headerActions,
	children,
}: DesktopLayoutProps) {

	return (
		<>
			<DesktopHeaderLayout
				headerType={headerType}
				headerActions={headerActions}
			/>
			<main className={mainClassName}>{children}</main>
			<LayoutFooter footerClassName={footerClassName} />
		</>
	);
}
